import { AxiosResponse } from "axios";
import { httpGet, httpPost } from "./AxiosHelper";
import { LoginRequest } from "../../models/LoginRquest";
import { RegisterRequest } from "../../models/RegisterRequest";
import { ChangePasswordBody } from "../../models/ChangePasswordBody";
import { VerifyOtpBody } from "../../models/VerifyOtpBody";
import { AppointmentBody } from "../../models/AppointmentBody";
import { BookedAppointmentDetails } from "../../models/BookedAppointmentDetails";
import { LeaveBody } from "../../models/LeaveBody";
import { IPatientList } from "../../models/PatientListModel";

// Login function
export const login = async (body: LoginRequest): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/auth/login",
      body: body,
    });
    if (response) {
      return response;
    } else {
      throw new Error("Login failed");
    }
  } catch (error: any) {
    throw new Error(error.message || "An error occurred during login");
  }
};

// Register function
export const register = async (formData: RegisterRequest): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/auth/register",
      body: formData,
    });

    return response;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const changePassword = async (
  body: ChangePasswordBody
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/auth/change-password",
      body: body,
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const forgotPassword = async (email: string): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/auth/forgot-password",
      body: email,
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const doLogout = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpGet({
      path: "api/auth/do-logout",
    });

    return response;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const verifyFirebaseOtp = async (idToken: string): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/auth/verify",
      body: idToken,
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const verifyOtp = async (body: VerifyOtpBody): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/auth/verify-otp",
      body: body,
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const bookAppointment = async (body: AppointmentBody): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/appointment/book-slot",
      body: body,
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

// return based on doctor | patient id
// return all booked details, under the login id,
export const getBookedAllAppointments = async (): Promise<
  BookedAppointmentDetails[]
> => {
  try {
    const response: AxiosResponse<BookedAppointmentDetails[]> = await httpGet({
      path: "api/appointment/get-booked-slots",
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const applyLeave = async (body: LeaveBody): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await httpPost({
      path: "api/leave/apply",
      body: body,
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const getMonthWiseLeave = async (month: any | 0): Promise<LeaveBody> => {
  try {
    const response: AxiosResponse<LeaveBody> = await httpGet({
      path: "api/leave/apply",
      queryParams: month,
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};

export const getAllPatients = async (): Promise<IPatientList[]> => {
  try {
    const response: AxiosResponse<IPatientList[]> = await httpGet({
      path: "api/dashboard/get-patients-list",
    });

    return response.data;
  } catch (error: any) {
    throw new Error("Network response was not ok");
  }
};
